import { baseClient } from 'builder/modules/apiClient'

export type Item = {
  id: string
  name: string
}
export type TransformedItem = {
  id: string
  text: string
}

let lastCountrySelected: string
let cachedStatesList: TransformedItem[] = []
let cachedIndustriesList: TransformedItem[] = []

const transformArray = (arr: Item[]): TransformedItem[] => {
  return arr.map(item => ({ id: item.id, text: item.name }))
}

const filterBy = (arr: TransformedItem[], query?: string): TransformedItem[] => {
  if (!query) return arr
  return arr.filter(item => item.text.toLowerCase().includes(query.toLowerCase()))
}

export const fetchStatesSuggestions = (countryId?: string) => async (query?: string) => {
  if (!countryId) return []
  try {
    if (lastCountrySelected === countryId && cachedStatesList.length) {
      return filterBy(cachedStatesList, query)
    }

    const url = `resume-distribution/datasets/countries/${countryId}/states`
    const response = await baseClient.get(url)

    const transformedArray = transformArray(response.data.data)
    cachedStatesList = transformedArray
    lastCountrySelected = countryId
    return filterBy(cachedStatesList, query)
  } catch (error) {
    return []
  }
}

export const fetchIndustriesSuggestions = async (category?: 'all' | 'top') => {
  try {
    if (cachedIndustriesList.length) {
      return cachedIndustriesList
    }

    const url = `resume-distribution/datasets/industries?category=${category || 'all'}`
    const response = await baseClient.get(url)
    cachedIndustriesList = response.data.data
    return response.data.data
  } catch (error) {
    return []
  }
}

export function convertFormDataToObject<T>(formData: FormData): T {
  const payload: Record<string, never> = {}

  for (const [key, value] of formData.entries()) {
    const keys = key.split(/[[\]]+/).filter(Boolean)

    keys.reduce((acc, k, i) => {
      acc[k] = acc[k] || (i === keys.length - 1 ? value : {})
      return acc[k]
    }, payload)
  }
  return payload as T
}
